




























































































































import { Vue, photosUrlEnum } from "../../constants/constants";
import {
  validateRestaurantMinOrderValue,
  updatePhotosURL,
  removeClassFromElements,
} from "../../helpers";
import { staticContent } from "../../localisation/detect-lang";
import { BasketLoadersEnum } from "../../models/basket.model";
import * as moment from "moment";

export default Vue.component("my-orders-controller", {
  data() {
    return {
      staticContent,
      photosUrlEnum,
      basketLoader: BasketLoadersEnum
    };
  },
  props: {},
  mounted() {   
    this.$root.MyOrdersPageInit();
  },

  computed: {
    ShouldILoadMorePrevious(){
      return this.$store.state.previousOrders.count!=this.$store.state.previousOrders.data.length;

    },
    ShouldILoadMoreCurrent(){
      return this.$store.state.currentOrders.count!=this.$store.state.currentOrders.data.length;

    },

    profile() {
      return this.$store.getters.getProfileData;
    },
    groupBasket() {
      return this.$store.state.groupBasket;
    },

    isGroupAdmin() {
      return (this.profile && this.profile.uuid) == this.adminuuid;
    },

    getCurrentOrders() {
      return this.$store.state.currentOrders.data;
    },
    getPreviousOrders() {
      return this.$store.state.previousOrders.data;
    },
 
    selectedOrder() {
      return this.$store.state.selectedOrder;
    },
    previousOrdersLoader() {
      return this.$store.state.previousOrdersLoader;
    },
    currentOrdersLoader() {
      return this.$store.state.currentOrdersLoader;
    }
  },

  methods: {
   

    loadMorePreviousOrders(){
       this.$store.dispatch("GET_MY_ORDERS", [this.$store.state.previousOrders.page+1, 10, "PREVIOUS"])
    },
    loadMoreCurrentOrders(){
       this.$store.dispatch("GET_MY_ORDERS", [this.$store.state.currentOrders.page+1, 10, "CURRENT"])

    },
    momentThis(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    getURL(url) {
      return this.$root.updatePhotosURL(
        url,
        this.$root.photosUrlEnum.version.thumbnail
      );
    },
    currentOrderFn(data, index) {
      //removeClassFromElements('order-item','active')
      //document.getElementById('current'+index).classList.add('active')
      document.getElementById('orders-controller').classList.add('my-orders-mobile')
      document.getElementById('orders-details').classList.remove('my-orders-mobile')

      this.$root.tabsHandler('orders-people-item-CURRENT','iditemmenuCURRENT')
      this.$store.dispatch("GET_SPECIFIC_ORDER", [data.uuid, "CURRENT"]).then(e=>{
        // this.$root.stopTracking();
         this.$store.commit("updateSelectedOrderType", "CURRENT");
      this.$root.selectOrder("CURRENT", data.uuid);
      $('html, body').animate({ scrollTop: 0 }, 'fast');
      })            
     
    },
    previousOrderFn(data, index) {
      //removeClassFromElements('order-item','active')
      //document.getElementById("prev" + index).classList.add('active')
      
        
      console.log(document.getElementById('orders-details').classList)
      this.$root.tabsHandler('orders-people-item-PREVIOUS','iditemmenuPREVIOUS')
      this.$store.dispatch("GET_SPECIFIC_ORDER", [data.uuid, "PREVIOUS"]).then(e=>{
         this.$root.stopTracking();
         this.$store.commit("updateSelectedOrderType", "PREVIOUS");
      this.$root.selectOrder("PREVIUOS", data.uuid);
      document.getElementById('orders-controller').classList.add('my-orders-mobile')
      document.getElementById('orders-details').classList.remove('my-orders-mobile')
      $('html, body').animate({ scrollTop: 10 }, 'fast');
      })            
     
    },
    reOrder(data) {
      this.$store.commit("updateSelectedOrderType", "PREVIOUS")
      this.$root.selectOrder("PREVIUOS", data.uuid);

      this.$store.dispatch("GET_SPECIFIC_ORDER", [data.uuid, "PREVIOUS"]).then(e=>{
           this.$root.handleReOrder(data.uuid);
      })            
     


     
    },
    


  }
});
